// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1d44cc8f","977":"49764df6"}[chunkId] + ".chunk.js";
};